import React, { useEffect, useContext, useState } from "react";
import { Box, Button, Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import HomeLayout from "layouts/HomeLayout";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import { getNewsList } from "context/actions/news";
import BestList from "components/BestList";
import ButtonList from "components/ButtonList";
import Cover from "components/Cover";
import Help from "components/Help";
import Location from "components/Location";
import Bank from "components/Bank";
import i18n from "i18next";
import { getLocationList } from "context/actions/location";
import { getConnectList } from "context/actions/connect";
import { getLinkList } from "context/actions/link";
import { getInstList } from "context/actions/inst";
import { getPriceList } from "context/actions/price";
import { getTimeList } from "context/actions/time";
import { getTrainingList } from "context/actions/training";
import { getInfoList } from "context/actions/info";
import useWindowSize from "utils/useWindowSize";
import { getCoverList } from "context/actions/cover";
import Slider from "components/Slider";
import Image from "next/image";
import {
  faSquareFacebook,
  faSquareInstagram,
  faSquareYoutube,
  faSquareTwitter,
} from "@fortawesome/free-brands-svg-icons";

const useStyles = makeStyles((theme) => ({}));

const HomePage = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const router = useRouter();
  const { sizes } = useWindowSize();
  const [location, setLocation] = useState([]);
  const [link, setLink] = useState([]);
  const [info, setInfo] = useState([]);
  const [price, setPrice] = useState([]);
  const [time, setTime] = useState([]);
  const [training, setTraining] = useState([]);
  const [connect, setConnect] = useState([]);
  const [covers, setCovers] = useState([]);

  useEffect(() => {
    getInitData();
  }, []);

  const getInitData = async () => {
    const resCover = await getLocationList();
    if (resCover.status === "success") setLocation(resCover.data);

    const resLink = await getLinkList();
    if (resLink.status === "success") setLink(resLink.data);

    const resInfo = await getInfoList();
    if (resInfo.status === "success") setInfo(resInfo.data.list);

    const resPrice = await getPriceList();
    if (resPrice.status === "success") setPrice(resPrice.data);

    const resTime = await getTimeList();
    if (resTime.status === "success") setTime(resTime.data);

    const resTraining = await getTrainingList();
    if (resTraining.status === "success") setTraining(resTraining.data);

    const resConnect = await getConnectList();
    if (resConnect.status === "success") setConnect(resConnect.data);

    const resCovers = await getCoverList();
    if (resCovers.status === "success") setCovers(resCovers.data);
  };

  const images = [
    { src: "/co.png", width: 90, height: 44, alt: "Nike" },
    { src: "/emart.webp", width: 90, height: 44, alt: "Reebok" },
    { src: "/nikelogo.png", width: 90, height: 44, alt: "Puma" },
    { src: "/zar.png", width: 90, height: 44, alt: "Adidas" },
    { src: "/addd.png", width: 120, height: 44, alt: "Reebok" },
    { src: "/ikes.png", width: 120, height: 44, alt: "Reebok" },
    { src: "/ham.png", width: 90, height: 44, alt: "Reebok" },
  ];

  return (
    <Container maxWidth={false} disableGutters={true} className="">
      <Container maxWidth={""} disableGutters={true} className="mt-20">
        <Box className="flex items-center justify-center w-full font-bold text-white text-[25px] leading-[1.167] ml-[15px] tracking-[-0.24px] font-roboto">
          <Image
            width={55}
            src={"/logo.jpg"}
            alt=""
            height={55}
            objectFit={"cover"}
            style={{ borderRadius: 10 }}
          />
          <Box className="ml-4">Гэгээ солонгос бараа</Box>
        </Box>
        <BestList linkData={link} />
        <Container maxWidth={"sm"} disableGutters={true} className="mt-20">
          <Box
            display="grid"
            gridTemplateColumns="repeat(auto-fit, minmax(180px, 1fr))"
            gap={2}
            justifyItems="center"
            alignItems="center"
          >
            {images.map((img, index) => (
              <Box key={index}>
                <Image
                  src={img.src}
                  width={img.width}
                  height={img.height}
                  alt={img.alt}
                  style={{ objectFit: "cover" }}
                />
              </Box>
            ))}
          </Box>
        </Container>
        <Box className="mt-10 text-[#fff] lex text-lg text-center md:flex-row justify-between items-start md:items-start-3 gap-6">
          Данс: Хаан 5400-71-81-91Болормаа <br /> Манай хаяг : Хан-уул дүүрэг
          Маршал хотхон <br />
          KING TOWER 118 байр <br />
          ⏰ Цагийн хуваарь: 11~19цаг. <br />
          Амралтын өдөр : Ням гаригт <br />
          ☎️ утас:89848191
          <br /> 🚚 Хүргэлтийн үйлчилгээ авах бол 89848191 дугаарт гүйлгээ
          хийсэн <br />
          дансны дугаар болон барааны тоо ширхэгээ мэссэж бичиж үлдээнэ үү.
          <br />
          <br />
        </Box>
      </Container>
    </Container>
  );
};

HomePage.Layout = HomeLayout;

export default HomePage;
